import React, { useEffect } from 'react';
import { HomeScreenConfiguration, Payload, ShopperExperienceDto } from '@luckycart/xpn-types';

import { HomeAcceptHtmlZone, HomeCtaButton } from './HomeScreen.style';
import { Background } from '../common-components/Background';
import { HtmlZone } from '../common-components/HtmlZone';
import { BlockInfoType } from '../../common-types/BlockInfo.type';
import { eventServiceInstance } from '../../utils/services/EventService';
import { useSearchParams } from 'react-router-dom';
import { Logger } from '../../utils/Logger';

interface Props {
  config: HomeScreenConfiguration;
  ctaOnClick?: React.MouseEventHandler<HTMLDivElement>;
  addEditableBlock?: (block: BlockInfoType) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  isSuScreen?: boolean;
  currentShopperExperience?: ShopperExperienceDto<Payload> | null;
}

export const HomeScreen: React.FunctionComponent<Props> = ({
  addEditableBlock,
  config,
  ctaOnClick,
  isEdition,
  onBlockEdit,
  isSuScreen,
  currentShopperExperience,
}: Props) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const siteKey = searchParams.get('siteKey');
    const shopperId = searchParams.get('shopperId');
    const cartId = searchParams.get('cartId');

    if (!currentShopperExperience || siteKey === null || shopperId === null || cartId === null) {
      Logger.log('Missing params to send game viewed event', {
        currentShopperExperience,
        siteKey,
        shopperId,
        cartId,
      });
      return;
    }

    eventServiceInstance.sendGameViewedEventToShopperEvent({
      siteKey,
      shopperId,
      cartId,
      operationId: currentShopperExperience.operationId,
      experienceId: currentShopperExperience.experienceId,
    });

  }, [searchParams, currentShopperExperience]);

  return (
    <Background
      displayName="Background"
      sizeInfo={{ height: 1200, width: 1200 }}
      addEditableBlock={addEditableBlock}
      dataTemplateConfig="screens.home.background"
      backgroundImage={config.background.imageUrl}
      backgroundColor={config.background.color}
      isEdition={isEdition}
      onClick={onBlockEdit}
    >
      <HtmlZone
        displayName="HTML Zone"
        addEditableBlock={addEditableBlock}
        html={config.mainTextBox.html}
        dataTemplateConfig="screens.home.mainTextBox"
        isEdition={isEdition}
        onClick={onBlockEdit}
      />
      <HomeCtaButton
        displayName="CTA"
        addEditableBlock={addEditableBlock}
        backgroundColor={config.ctaButton.background.color}
        innerHTML={config.ctaButton.html}
        onClick={onBlockEdit === undefined ? ctaOnClick : onBlockEdit}
        dataTemplateConfig="screens.home.ctaButton"
        isEdition={isEdition}
      />
      <HomeAcceptHtmlZone
        displayName="Accept HTML Zone"
        addEditableBlock={addEditableBlock}
        html={config.acceptTextBox.html}
        dataTemplateConfig="screens.home.acceptTextBox"
        isEdition={isEdition}
        onClick={onBlockEdit}
      />
    </Background>
  );
};
